import VacationModeSettings from './VacationModeSettings';

export default VacationModeSettings;
